import dayjs from "dayjs";
import { Day } from "../types/global";
import { IHoliday } from "../../@types/holiday.type";

export const daysInYear = (year: number) =>
  (year % 4 === 0 && year % 100 > 0) || year % 400 === 0 ? 366 : 365;

export const getIsBusinessDay = (date: dayjs.Dayjs) => {
  const day = date.day();
  return day !== 0 && day !== 6;
};

export const getIsHoliday = (date: dayjs.Dayjs, listHolidays: IHoliday[] = []) => {
  return listHolidays?.some((holiday) => {
    const holidayDate = dayjs(holiday.holidayDate);

    if (holiday.recurrent) {
      return date.date() === holidayDate.date() && date.month() === holidayDate.month();
    }

    return date.isSame(holidayDate, "day");
  });
};

export const calculateBusinessDays = (
  startDate: dayjs.Dayjs,
  endDate: dayjs.Dayjs
): number => {
  let current = startDate.startOf("day");
  const end = endDate.startOf("day");
  let businessDays = 0;
  while (!current.isAfter(end)) {
    const dow = current.day();
    if (dow !== 0 && dow !== 6) businessDays++;
    current = current.add(1, "day");
  }
  return Math.max(0, businessDays);
};

export const getDaysInMonths = (date: Day, iterator: number) =>
  dayjs(`${date.year}-${date.month + 1}-${date.dayOfMonth}`)
    .add(iterator, "months")
    .daysInMonth();

export const parseDay = (
  data: dayjs.Dayjs,
  listHolidays: IHoliday[] = [],
): Day => {

  return {
    hour: data.hour(),
    dayName: data.format("ddd"),
    dayOfMonth: data.date(),
    weekOfYear: data.isoWeek(),
    month: data.month(),
    monthName: data.format("MMMM"),
    isBusinessDay: getIsBusinessDay(data),
    isCurrentDay: data.isSame(dayjs(), "day"),
    isHoliday: listHolidays.length > 0 ? getIsHoliday(data, listHolidays) : false, 
    year: parseInt(data.format("YYYY")),
  };
};
